import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success("If the email exists, a reset link has been sent.");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-page py-20 max-w-md" data-testid="forgot-password-page">
      <h1 className="text-3xl font-heading font-semibold text-ink">Forgot password</h1>
      <p className="mt-2 text-muted2">Enter your email and we'll send a reset link.</p>
      {done ? (
        <div className="mt-8 rounded-2xl bg-cardm p-6 border border-subtle">
          <p className="text-ink">If an account exists for <strong>{email}</strong>, a reset link is on its way.</p>
          <Link to="/login" className="mt-4 inline-block text-moss font-medium hover:underline">Back to login</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="block text-sm font-medium text-ink mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email-input"
              className="w-full rounded-xl border border-subtle bg-white px-4 py-3 text-ink focus:border-moss focus:outline-none focus:ring-2 focus:ring-moss/20 transition-all" />
          </div>
          {error && <p className="text-sm text-danger">{error}</p>}
          <button type="submit" disabled={busy} data-testid="forgot-submit-button"
            className="w-full bg-terra hover:bg-terra-dark text-white rounded-full px-6 py-3 font-semibold transition-all active:scale-95 disabled:opacity-60">
            Send reset link
          </button>
          <Link to="/login" className="block text-center text-sm text-moss hover:underline">Back to login</Link>
        </form>
      )}
    </div>
  );
}
